export default {
	sec_10: {
		title: {
			one: 'Currency exchange ',
			two: 'like a bank',
		},
		desc: {
			one: 'Are you still going back and forth selling and',
			two: 'buying and exchanging money?',
		},
		btn: {
			one: 'Sign up',
			two: 'Download App',
		},
	},
	sec_04: {
		title: {
			one: 'Exchange money and',
			two: 'send it right away',
		},
		desc: {
			one: 'Still struggling to buy and send cryptocurrencies?',
			two: 'Use it like a bank. Instantly transfer and withdraw funds.',
		},
		cards: {
			one: {
				title: {
					one: 'Exchange your currency easily',
					two: 'with one click of a button',
				},
				description: {
					one: 'Automatic exchange rates, automatic sales.',
					two: 'A very simple interface.',
				},
			},
			two: {
				title: {
					one: 'Any asset you want, anytime',
				},
				description: {
					one: 'Cryptocurrency exchange is also possible. ',
					two: 'Cryptocurrency can also be exchanged ',
					three: 'for JPYS points.',
				},
			},
		},
	},
};
